import can from "../js/can";

require('../js/bootstrap');
const moment = require('moment');
require('moment/locale/ru');
require('moment/locale/uz-latn');

import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router';
import routes from './routes';
import vuex from './store';
import Api from '../js/services/ApiPlugin';
import Notifications from 'vue-notification';
import Moment from 'vue-moment';
import Datepicker from 'vuejs-datepicker';
import VueMousetrap from "vue-mousetrap";
import VueI18n from 'vue-i18n';

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(Api);
Vue.use(Notifications);
Vue.use(Moment, {
    moment
});
Vue.use(VueMousetrap);
Vue.use(Datepicker);
Vue.use(VueI18n);

Vue.mixin({
    methods: {
        i18n(value) {
            let current = this.$store.state.currentLang;
            let basket = this.$store.state.lang[current];
            if (basket !== undefined) {
                let word = basket[value];
                if (word !== undefined) {
                    return word;
                }
            }
            return value;
        }
    }
});


let router = new VueRouter({
    linkExactActiveClass: 'active',
    routes: routes,
    mode: 'history'
});

import messages from '../infokiosk/messages';
import route from "../js/urlex/route";
const i18n = new VueI18n({
    locale: 'ru', // set locale
    messages, // set locale messages
});

const store = new Vuex.Store(vuex);

let app = new Vue({
    el: '#app',
    router: router,
    store,
    // i18n,
    mounted() {
    },
    methods: {}
});
